import React from 'react';
import { Grid, Button, Card, CardMedia, Typography, CardActions, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSlider } from '../../hooks/useSlider';
import UploadImg from '../../assets/images/ui/add-image-wide.png';
import Loader from '../../components/Loader/Loader';


const Slider = () => {
  const navigate = useNavigate();
  const { sliders, loading } = useSlider();

  return loading ? (
    <Loader />
  ) : (
    <>
      <Grid container spacing={3} sx={{ marginTop: '0.5rem' }}>
        {sliders.map((item) => (
          <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={item._id}>
            <Card sx={{ maxWidth: 350, minWidth: 350, width: '100%' }}>
              <CardMedia
                component="img"
                alt={item.images[0] ? item.images[0].name : UploadImg}
                height="200"
                image={item.images[0] ? item.images[0].path + '?width=350&height=300&crop=fill' : UploadImg}
              />
              <CardContent>
                <Typography gutterBottom variant="subtitle1" noWrap>
                  {item.name}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {item.projectType}
                </Typography>
                <Typography gutterBottom variant="overline" component="h2">
                  {item.images ? 'Contains ' + item.images.length + ' Images' : 'No Images'}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={() => navigate(`/slider-edit?id=${item._id}`, { state: { mode: 'edit' } })}>
                  Edit
                </Button>
                <Button size="small" color="error">
                  Delete
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Slider;
